import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking } from "../../utils/tracking";
import type { Icon } from "../../@types/mapviewxs";
export interface Input {
  "on-zoom-in": () => void;
  "on-zoom-out": () => void;
  zoomIn?: Icon;
  zoomOut?: Icon;
}

<div class="map-zoom" key="map-zoom">
  <div class="map-component-with-tooltip">
    <span class="map-component-tooltip">
      <fe-textual-display model=t("mapview/map", "zoomInTooltipLabel")/>
    </span>
    <button class="zoom-control zoom-in" on-click("emit", "zoom-in") ...getPropsForClickTracking(input.zoomIn?.action?.trackingList)>
      <ebay-add-16-icon/>
    </button>
  </div>
  <div class="separator"/>
  <div class="map-component-with-tooltip">
    <span class="map-component-tooltip">
      <fe-textual-display model=t("mapview/map", "zoomOutTooltipLabel")/>
    </span>
    <button class="zoom-control zoom-out" on-click("emit", "zoom-out") ...getPropsForClickTracking(input.zoomOut?.action?.trackingList)>
      <ebay-remove-16-icon/>
    </button>
  </div>
</div>
